import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Comunicazione from './Index';

class WrapperComunicazione extends Component {
  componentDidMount() {
    this.notificaComunicazioneSelezionato();
  }

  componentDidUpdate() {
    this.notificaComunicazioneSelezionato();
  }

  notificaComunicazioneSelezionato() {
    const { comunicazioneSelezionata } = this.context;
    const { match } = this.props;
    comunicazioneSelezionata(match.params.idComunicazione);
  }

  static propTypes = {
    profilo: PropTypes.any,
    ufficioSelezionato: PropTypes.string,
  };

  render() {
    return (
      <Comunicazione
        messaggio={this.context.comunicazioni.filter((x) => x.IdInvio == this.props.match.params.idComunicazione)[0]}
        segnaComeLetta={this.context.segnaComeLetta}
        router={this.context.router}
        profilo={this.props.profilo}
        ufficioSelezionato={this.props.ufficioSelezionato}
      />
    );
  }
}

WrapperComunicazione.contextTypes = {
  comunicazioni: PropTypes.array,
  segnaComeLetta: PropTypes.func,
  comunicazioneSelezionata: PropTypes.func,
  router: PropTypes.object,
};

const mapStateToProps = (state) => ({ profilo: state.profilo, ufficioSelezionato: state.ufficioSelezionato });

export default connect(
  mapStateToProps,
  null,
)(WrapperComunicazione);
